<template>
  <section class="base-page">
    <PageHeader class="base-shadow"></PageHeader>
    <keep-alive><FilterSection @change="onFilterChange"/></keep-alive>
    <BasicTable
      showSelection
      hiddenClear
      :loading="tableLoading"
      :tableColumns="tableColumns"
      :tableData="tableData"
      :page="page"
      :size="size"
      :total="total"
      :orderDirection="orderDirection"
      :orderProp="orderProp"
      @onSortChange="onTableSortChange"
      @onSizeChange="handleSizeChange"
      @onPageChange="handlePageChange"
      @onRefresh="onRefresh"
      @onSelectionChange="onSelectionChange"
    >
      <template #tableControl>
        <el-button
          class="mt-r"
          size="small"
          type="primary"
          icon="el-icon-document-add"
          @click="addRow"
          v-if="checkPermission(['NEWS_ADMIN'])"
          >新增</el-button
        >
        <el-button
          v-if="checkPermission(['NEWS_ADMIN'])"
          size="small"
          @click="onMultipleToggleDisable(false)"
          :disabled="multipleSelected.length <= 0"
          >批量启用 {{ multipleSelected.length }}</el-button
        >
        <el-button
          size="small"
          v-if="checkPermission(['NEWS_ADMIN'])"
          @click="onMultipleToggleDisable(true)"
          :disabled="multipleSelected.length <= 0"
          >批量禁用 {{ multipleSelected.length }}</el-button
        >
        <el-checkbox class="mt-l mt-r" v-model="showDisable" @change="onSearch"
          >显示禁用</el-checkbox
        >
        &nbsp; &nbsp;
      </template>
      <template v-for="column in tableColumns">
        <el-table-column
          v-if="column.prop !== 'controlColumn' && column.showColumn"
          v-bind="column"
          :show-overflow-tooltip="true"
          :key="column.prop"
        >
          <template slot-scope="scope">
            <span v-if="column.prop === 'gmt_create'">{{
              scope.row.gmt_create | date_time
            }}</span>
            <span v-else-if="column.prop === 'gmt_modified'">{{
              scope.row.gmt_modified | date_time
            }}</span>
            <span v-else-if="column.prop === 'title'">
              <span
                style="padding-left: 5px"
                title="点击查看详情"
                class="text-nav"
                @click="onShowDetail(scope.row)"
                >{{ scope.row.title }}</span
              >
            </span>

            <span v-else-if="column.prop === 'disabled'">
              <el-tag
                :type="scope.row.disabled ? 'danger' : 'success'"
                @click="toggleDisableRow(scope.row, scope.$index)"
                >{{ scope.row.disabled ? "已禁用" : "已启用" }}</el-tag
              >
            </span>

            <span v-else-if="column.prop === 'content'">
              <span class="text-nav" @click="onShowDetail(scope.row)"
                >点击查看</span
              >
            </span>

            <span v-else-if="column.prop === 'cover_image_url'">
              <el-image
                style="width: 50px; height: 50px"
                :src="scope.row.cover_image_url"
                :preview-src-list="[scope.row.cover_image_url]"
              >
              </el-image>
            </span>

            <span v-else>{{ scope.row[column.prop] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="column.prop === 'controlColumn' && column.showColumn"
          v-bind="column"
          :key="column.prop"
        >
          <template slot-scope="scope">
            <el-dropdown>
              <span class="el-dropdown-link drop-down-menu-link">
                更多操作<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-if="scope.row.canUpdate"
                  @click.native.prevent="editRow(scope.row, scope.$index)"
                  >编辑</el-dropdown-item
                >

                <el-dropdown-item
                  v-if="scope.row.canDisable"
                  :class="[scope.row.disabled ? 'text-success' : 'text-danger']"
                  @click.native.prevent="
                    toggleDisableRow(scope.row, scope.$index)
                  "
                >
                  {{ scope.row.disabled ? "启用" : "禁用" }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </template>
      <template #multipleControl> </template>

      <el-drawer
        title="Blogs详情"
        :visible.sync="detailDialog"
        append-to-body
        direction="rtl"
        size="70%"
      >
        <Detail :id="currentId" />
      </el-drawer>
    </BasicTable>
  </section>
</template>

<script>
import BasicTable from "@/components/BasicTable";
import Detail from "./components/Detail";
import { ShowApiError } from "@/request/error";
import { getOrderType } from "@/utils/common";
import { GetTableOrderParams } from "@/utils/table";
import { isEmprty } from "@/utils/validate";
import { checkPermission } from "@/utils/auth";
import FilterSection from "./components/FilterSection";
import {
  GetBlogsList,
  GetUpdateCheck,
  GetDiasbleCheck,
  ToggleDisableById,
} from "./api";
import PageHeader from "@/components/PageHeader";
import {
  FormatMultipleItemIds,
  GetTableDisableMessage,
  ReadLocalColumn,
} from "@/utils/table";

import config from "@/config";
export default {
  components: {
    BasicTable,
    FilterSection,
    PageHeader,
    Detail,
  },
  data() {
    return {
      formDialog: false,
      tableLoading: false,
      bindEntWxDialog: false,
      detailDialog: false,
      tableColumns: [],
      page: 0,
      size: config.TABLE_SIZE,
      total: 0,
      tableData: [],
      tableFilters: {
        gmt_create: null,
        gmt_modified: null,
        departmentId: null,
        rolesId: null,
        name: "",
        phoneNo: "",
      },
      showDisable: false,
      orderProp: "seq",
      orderDirection: "descending",
      currentId: null,
      multipleSelected: [],
      multipleDisableLoading: false,
      orderPropObj: {},
    };
  },
  created() {
    this.buildTableColumns();
    this.getTableData();
  },
  methods: {
    isEmprty,
    checkPermission,
    buildTableColumns(columns = []) {
      if (columns.length > 0) {
        this.tableColumns = columns;
      } else {
        let columns = [
          {
            prop: "disabled",
            label: "是否禁用",
            showColumn: true,
            width: 110,
            align: "center",
            fixed: "left",
            sortable: "custom",
          },
          {
            prop: "seq",
            label: "次序",
            showColumn: true,
            align: "center",
            width: 100,
            sortable: "custom",
          },
          {
            prop: "cover_image_url",
            label: "封面图",
            showColumn: true,
            align: "center",
            minWidth: 100,
            sortable: "custom",
          },
          {
            prop: "title",
            label: "标题",
            minWidth: 130,
            showColumn: true,
            align: "left",
            fixed: false,
            sortable: "custom",
          },
          {
            prop: "sub_title",
            label: "摘要",
            minWidth: 180,
            showColumn: true,
            align: "left",
            sortable: "custom",
          },

          {
            prop: "content",
            label: "内容",
            showColumn: true,
            align: "center",
            width: 100,
            sortable: "custom",
          },
          {
            prop: "gmt_create",
            label: "创建时间",
            showColumn: true,
            width: 200,
            align: "center",
            sortable: "custom",
          },
          {
            prop: "user_name_create",
            label: "创建人",
            showColumn: true,
            align: "center",
            minWidth: 150,
            sortable: "custom",
          },
          {
            prop: "gmt_modified",
            label: "更新时间",
            showColumn: true,
            width: 200,
            align: "center",
            sortable: "custom",
          },
          {
            prop: "user_name_modified",
            label: "更新人",
            showColumn: true,
            align: "center",
            minWidth: 150,
            sortable: "custom",
          },
          {
            prop: "id",
            label: "ID",
            idth: 80,
            showColumn: true,
            align: "left",
            fixed: false,
            sortable: "custom",
          },

          {
            prop: "controlColumn",
            fixed: "right",
            align: "center",
            showColumn: true,
            label: "操作",
            width: 100,
          },
        ];
        this.tableColumns = ReadLocalColumn(this.$route, columns);
      }
    },
    handleSizeChange(val) {
      this.page = 0;
      this.size = val;
      this.getTableData();
    },
    handlePageChange(val) {
      this.page = val - 1;
      this.getTableData();
    },
    filterParams() {
      return {
        ...this.tableFilters,
      };
    },
    
    onCheckUpdate(item) {
      GetUpdateCheck(item.id)
        .then((res) => {
          item.canUpdate = res.data;
        })
        .catch(() => {
          item.canUpdate = true;
        });
    },
    onCheckDisbale(item) {
      GetDiasbleCheck([item.id])
        .then((res) => {
          item.canDisable = res.data;
        })
        .catch(() => {
          item.canDisable = true;
        });
    },

    getControlColumn() {
      return {
        canUpdate: false,
        canDisable: false,
      };
    },
    getTableData() {
      this.tableLoading = true;
      GetBlogsList({
        page: this.page,
        size: this.size,
        sort: GetTableOrderParams(
          this.orderProp,
          this.orderDirection,
          this.orderPropObj
        ),
        disabled: this.showDisable,
        ...this.filterParams(),
      })
        .then((res) => {
          let { content, total_elements } = res.data;
          this.tableData = content.map((item) => {
            return {
              ...item,
              ...this.getControlColumn(),
            };
          });

          this.tableData.forEach((item) => {
            this.onCheckUpdate(item);
            this.onCheckDisbale(item);
          });

          this.total = total_elements;
          // 加载状态结束
          this.tableLoading = false;
        })
        .catch((err) => {
          this.tableLoading = false;
          ShowApiError("拉取列表错误", err);
        });
    },
    onRefresh() {
      this.getTableData();
    },
    onSearch() {
      this.page = 0;
      this.getTableData();
    },
    addRow() {
      this.$router.push({
        name: "BlogForm",
        params: {
          id: null,
        },
      });
    },
    editRow(row) {
      if (row.canUpdate) {
        this.$router.push({
          name: "BlogForm",
          params: {
            id: row.id,
          },
          query: {
            name: row.id,
          },
        });
      } else {
        this.$message.warning("没有权限执行此操作!");
      }
    },
    onTableSortChange({ prop, order }) {
      if (order === null) {
        this.orderProp = "seq";
        this.orderDirection = "descending";
      } else {
        this.orderDirection = order;
        this.orderProp = prop;
      }
      this.page = 0;
      this.onRefresh();
    },
    onSelectionChange(selections) {
      this.multipleSelected = selections;
    },
    onFilterChange(data) {
      this.tableFilters = data;
      this.page = 0;
      this.onRefresh();
    },

    onShowDetail(row) {
      this.currentId = row.id;
      this.detailDialog = true;
    },

    toggleDisableRow(row, index) {
      if (row.canDisable) {
        ToggleDisableById([row.id], !row.disabled).then(() => {
          row.disabled = !row.disabled;
          this.$set(this.tableData, index, row);
          this.$message.success("操作成功!");
        });
      } else {
        this.$message.warning("没有权限执行此操作!");
      }
    },
    // 批量：启用/禁用
    onMultipleToggleDisable(flag = false) {
      if (this.multipleSelected.length <= 0) {
        return false;
      }
      let { ids, nameString, unableControl } = FormatMultipleItemIds({
        multipleSelectes: this.multipleSelected,
        nameKey: "title",
      });
      let message = GetTableDisableMessage({
        total: this.multipleSelected.length,
        ableControlCount: ids.length,
        unableControlCount: unableControl.length,
        nameString: nameString,
        flag: flag,
        ableText: "启用",
        unAbleText: "禁用",
      });
      this.$msgbox({
        title: `${flag ? "禁用" : "启用"}提示`,
        message: message,
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (ids.length <= 0) {
              this.$message.info("无有效数据可操作");
              done();
              return;
            }
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "执行中...";
            ToggleDisableById(ids, flag)
              .then(() => {
                this.$message.success("操作成功");
                this.multipleSelected = [];
                this.onRefresh();
              })
              .catch((err) => {
                ShowApiError(err, "操作请求错误");
              })
              .finally(() => {
                done();
                instance.confirmButtonLoading = false;
                instance.confirmButtonText = "";
              });
          } else {
            instance.confirmButtonLoading = false;
            instance.confirmButtonText = "";
            done();
          }
        },
      });
    },

    onFormCancel() {
      this.currentId = null;
      this.formDialog = false;
    },
    onFormSuccess() {
      this.formDialog = false;
      if (!isEmprty(this.currentId)) {
        // 修改模式下只更新当页数据
        this.onRefresh();
      } else {
        // 新增模式下，新增成功后返回第一页
        this.page = 0;
        this.onRefresh();
      }
      this.currentId = null;
    },
  },
};
</script>

<style lang="scss" scoped></style>
